import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MobileAppPromptComponent } from './components/shared/mobile-app-prompt/mobile-app-prompt.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MobileAppPromptComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'nssfgo-redisgn';
}
